module.exports = __webpack_public_path__ + "static/media/scheme2.9cb11f1a.png";